import { NormalSelectOptions } from "@app/components/select/select.type";

export enum UserType {
  FREE = "FREE",
  VIP = "VIP",
}

export const UserTypeOptions: NormalSelectOptions = [
  { label: UserType.FREE, value: UserType.FREE },
  { label: UserType.VIP, value: UserType.VIP },
];
